import { BaseApiService } from '@/shared/api/services/base.service';
import type { UsageResponse, UsageStatsResponse } from '@/types/user';

export interface DeletionStatusResponse {
  data: {
    type: string;
    id: string;
    attributes: {
      is_scheduled_for_deletion: boolean;
      scheduled_deletion_at: string | null;
      can_cancel_deletion: boolean;
      days_remaining: number | null;
    };
  };
}

/**
 * User service for user-related operations
 */
class UserService extends BaseApiService {
  /**
   * Get usage information
   */
  async getUsage(): Promise<UsageResponse> {
    return this.httpGet('/v1/usage');
  }

  /**
   * Get detailed usage statistics
   */
  async getUsageStats(): Promise<UsageStatsResponse> {
    return this.httpGet('/v1/usage/stats');
  }

  /**
   * Update user locale
   */
  async updateLocale(locale: string): Promise<void> {
    await this.put('/v1/user/locale', {
      data: {
        type: 'default',
        attributes: { locale },
      },
    });
  }

  /**
   * Request account deletion with 3-day grace period
   */
  async requestAccountDeletion(
    reason?: string
  ): Promise<DeletionStatusResponse> {
    return this.post('/v1/user/deletion', {
      data: {
        type: 'user',
        attributes: {
          ...(reason && { reason }),
        },
      },
    });
  }

  /**
   * Cancel scheduled account deletion
   */
  async cancelAccountDeletion(): Promise<void> {
    await this.httpDelete('/v1/user/deletion');
  }
}

export const userService = new UserService();
export default userService;
